import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  PurchaseReportService
} from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./fabricBendingReport.html"
})
export class fabricBendingReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  season = "";
  gridOptions: any;
  dataList = [];
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  exceldata: any;
  statusList = ["DELIVERED", "PENDING"];
  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  coreList = ["CORE", "NEW", "BOTH"];
  filter = {
    finyear: "",
    season: "",
    group: "",
    groupby: "PARTY",
    sample_no: "",
    status: "DELIVERED",
    season_id: "",
    fin_id: ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "asc"
  };
  printConfig: any = {
    title: "Agent Yearly report",
    columns: [],
    rows: []
  };

  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["QUALITY", "PARTY", "TYPE"];

  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purReport: PurchaseReportService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService
  ) {}

  ngOnInit(): void {
    this.finyearCombo();
    this.getColumns();
    this.getOrderList();
    this.toggleCol = Object.assign({}, this.columns);
  }
  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
        headerClass: "text-center"
      },
      {
        name: "PO No",
        prop: "po_no",
        cellClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center"
      },
      {
        name: "Order Date",
        prop: "po_date",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center"
      },
      {
        name: "Party Code",
        prop: "party_code",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
        headerClass: "text-center"
      },
      {
        name: "Party Name",
        prop: "party_name",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
        headerClass: "text-center"
      },
      {
        name: "Indent No",
        prop: "indent_no",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center"
      },
      {
        name: "Transport",
        prop: "transport",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center"
      },
      {
        name: "Agent",
        prop: "agent",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center"
      },
      {
        name: "Total Amount",
        prop: "totalamt",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center"
      },
      {
        name: "No of Designs",
        prop: "no_of_design",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center"
      }
    ];
    debugger;

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: []
    };
    console.log(this.gridOptions.columns);
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function() {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  applyFilter(season, finyear, status): void {
    debugger;
    if (finyear) {
      let parFinyear = _.filter(this.finyearList, { finyear: finyear });
      this.filter.fin_id = parFinyear[0].fin_id;
      this.getSeasonList(season);
      if (season) {
        let parSeason = _.filter(this.seasonList, { season: season });
        this.filter.season_id = parSeason[0].season_id;
        this.filter.season = parSeason[0].season;
      }
    }
  }
  getSeasonList(season) {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
      fin_id: this.filter.fin_id
    };
    let that = this;
    that.purReport.getSeason(params).then((res: any) => {
      that.seasonList = res;
      let curDate = new Date();
      var now =
        curDate.getFullYear() +
        "-" +
        0 +
        Number(curDate.getMonth() + 1) +
        "-" +
        curDate.getDate();
      that.seasonList.forEach(el => {
        if (now > el.rd_from && now < el.rd_to) {
          that.filter.season = el.season;
          that.filter.season_id = el.season_id;
        }
      });

      if (season) {
        let parSeason = _.filter(this.seasonList, { season: season });
        that.filter.season_id = parSeason[0].season_id;
        that.filter.season = parSeason[0].season;
      }
      this.getOrderList();
    });
  }
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.filter.fin_id = res.data[0].fin_id;
      that.filter.finyear = res.data[0].finyear;
      that.getSeasonList("");
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  codelist() {
    this.poservice.codelist({}).then((res: any) => {
      this.partycodeList = res.data;
    });
  }
  openScreen(evant) {
    let tabObj = {};
    let mode = "View";
    let row = evant.row;
    tabObj = {
      action: "NewTab",
      params: {
        //   tabParent: 'Transaction',
        tabName: "VIEW PURCHASE ORDER",
        title: "VIEW PURCHASE ORDER",
        tabParent: "CLOTH",
        mode: mode,
        data: row,
        name: "VIEW PURCHASE ORDER"
      }
    };
    this.tabUpdateEvent.emit(tabObj);
  }

  getOrderList(): void {
    debugger;
    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter)
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: []
    };
    debugger;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.purReport
      .getFabricBendingReport(params)
      .then(function(res: any) {
        console.log(res);
        console.log(params);
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.array;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.array,
          loading: false
        };
        that.printConfig = {
          title: "Purchase Order Report",
          columns: res.columns,
          rows: that.orderList
        };
        that.exceldata = that.getData(res.columns, res.array);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary"
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/purchaseOrderReport/fabricBendingReport.ts